import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  currentStep: 0,
  totalSteps: 8,
  completed: false,
  data: {
    // Step 2: Board Setup
    boardSettings: {
      wipLimits: {
        backlog: null,
        todo: 5,
        inProgress: 3,
        done: null // No limit
      }
    },
    // Step 3: First Stream
    firstStream: {
      name: '',
      description: '',
      template: null
    },
    // Step 4: MFA Setup
    mfaSetup: {
      completed: false,
      skipped: false
    }
  },
  skippedSteps: []
}

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    // Navigation
    nextStep: (state) => {
      if (state.currentStep < state.totalSteps - 1) {
        state.currentStep += 1
      }
    },
    previousStep: (state) => {
      if (state.currentStep > 0) {
        state.currentStep -= 1
      }
    },
    goToStep: (state, action) => {
      const step = action.payload
      if (step >= 0 && step < state.totalSteps) {
        state.currentStep = step
      }
    },

    // Board Settings
    updateBoardSettings: (state, action) => {
      state.data.boardSettings = {
        ...state.data.boardSettings,
        ...action.payload
      }
    },
    updateWipLimits: (state, action) => {
      state.data.boardSettings.wipLimits = {
        ...state.data.boardSettings.wipLimits,
        ...action.payload
      }
    },

    // First Stream
    updateFirstStream: (state, action) => {
      state.data.firstStream = {
        ...state.data.firstStream,
        ...action.payload
      }
    },
    setStreamTemplate: (state, action) => {
      const templates = {
        'product-launch': {
          name: 'Product Launch',
          description: 'Plan and execute your product launch'
        },
        'ideas': {
          name: 'Ideas',
          description: 'Capture and develop your creative ideas'
        },
        'personal-goals': {
          name: 'Personal Goals',
          description: 'Track and achieve your personal objectives'
        }
      }
      const template = templates[action.payload]
      if (template) {
        state.data.firstStream = {
          ...state.data.firstStream,
          ...template,
          template: action.payload
        }
      }
    },

    // MFA Setup
    updateMFASetup: (state, action) => {
      state.data.mfaSetup = {
        ...state.data.mfaSetup,
        ...action.payload
      }
    },
    markMFACompleted: (state) => {
      state.data.mfaSetup.completed = true
      state.data.mfaSetup.skipped = false
    },
    markMFASkipped: (state) => {
      state.data.mfaSetup.skipped = true
      state.data.mfaSetup.completed = false
    },

    // Skip handling
    skipStep: (state) => {
      if (!state.skippedSteps.includes(state.currentStep)) {
        state.skippedSteps.push(state.currentStep)
      }
      // Move to next step
      if (state.currentStep < state.totalSteps - 1) {
        state.currentStep += 1
      }
    },

    // Completion
    completeOnboarding: (state) => {
      state.completed = true
      state.currentStep = state.totalSteps - 1 // Move to completion step
    },

    // Reset
    resetOnboarding: () => initialState
  }
})

export const {
  nextStep,
  previousStep,
  goToStep,
  updateBoardSettings,
  updateWipLimits,
  updateFirstStream,
  setStreamTemplate,
  updateMFASetup,
  markMFACompleted,
  markMFASkipped,
  skipStep,
  completeOnboarding,
  resetOnboarding
} = onboardingSlice.actions

export default onboardingSlice.reducer
